import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import iconCaretDown from "../../assets/svg/caret-down.svg";
import { IMenuCategoryLink } from "../../utils/menu.interface";

import siteNavStyles from "../../styles/composable/site-nav.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<{
    isMobile: boolean;
    modalIsOpen: boolean;
    linkObject: IMenuCategoryLink;
}> & {
    openModal: (event: React.MouseEvent<HTMLElement>) => void;
};

export const CategoryLink = ({
    isMobile,
    modalIsOpen,
    linkObject,
    openModal,
}: IProps): React.ReactNode => {
    if (isMobile) {
        return (
            <div
                key={linkObject.value.title}
                className={concatClassNames([
                    styles.mainDropdownMenuMobile,
                    styles.mainDropdownMenuMobileLink,
                ])}
            >
                {linkObject.value.title}
            </div>
        );
    }

    const categoryLinkClass = concatClassNames([
        siteNavStyles.siteNavMainMenuItem,
        `site-nav__main-menu-item--${linkObject.value.title
            .replace(/\s+/g, "-")
            .toLowerCase()}`,
        siteNavStyles.siteNavMainMenuItemHoverState,
        modalIsOpen ? siteNavStyles.siteNavMainMenuItemHoverCategoryLink : null,
    ]);

    return (
        <span key={linkObject.value.title}>
            <button
                onClick={(e) => {
                    openModal(e);
                }}
                className={categoryLinkClass}
            >
                {linkObject.value.title}
                <SVG
                    src={iconCaretDown}
                    className={siteNavStyles.siteNavShopIcon}
                    aria-hidden="true"
                />
            </button>
        </span>
    );
};
